import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-point-down",
  "use": "icon-point-down-usage",
  "viewBox": "0 0 8 6",
  "content": "<symbol viewBox=\"0 0 8 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-point-down\">\n<path d=\"M4.35268 5.35333L7.68602 1.35333C7.82602 1.21333 7.87268 0.993333 7.79268 0.806667C7.71935 0.62 7.53268 0.5 7.33268 0.5H0.666016C0.466016 0.5 0.279349 0.62 0.206016 0.806667C0.179349 0.873333 0.166016 0.933333 0.166016 1C0.166016 1.13333 0.219349 1.26 0.312682 1.35333L3.64602 5.35333C3.83935 5.54667 4.15935 5.54667 4.35268 5.35333Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol